
<accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-users'></i> Información de Referencias Bancarias / Comerciales
      </span>
      <button [hidden]="disabled" type="button" class="btn btn-outline-primary mb-4" (click)="addReference()"><i class="fa fa-address-book"></i>&nbsp;Agregar Referencia</button>
      <pos-table [data]="bankingReferenceTable" [pagination]="false" [headers]="getBankingReferenceTableHeaders()" [disableHighlight]="true" highlightSuccessDangerField="status" ></pos-table>
      <div class="form-horizontal">
        <div class="row">
        </div>
        <div class="row col-12">
        </div>
    </div>
    </accordion-group>
    
</accordion>